import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { SHARE_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const ShareIcon = (props: IconGlyphProps) => <Icon {...props} glyph={SHARE_GLYPH} />;
